import { Card, Divider, Text } from "@shopify/polaris"
import React from "react"

import { hasPermission } from "@/component"
import HotBadge from "@/component/HotBadge/HotBadge"
import PermissionBadge from "@/component/PermissionBadge"
import Permission from "@/enums/permission"

interface ListCardProps {
  title: string | React.ReactNode
  description: string | React.ReactNode
  isHot?: boolean

  permission?: Permission
  titleRight?: string | React.ReactNode
  children?: string | React.ReactNode
}

const ListCard = ({
  title,
  description,
  isHot,
  permission,
  titleRight,
  children,
}: ListCardProps) => {
  return <Card>
    <div className={"flex items-start justify-between flex-wrap gap-2 flex-row"}>
      <div className={"flex-1"}>
        <Text as={"h3"} variant={"headingMd"}>
          <div className={"flex items-center"}>
            <div className={"flex items-center gap-1"}>{title} {isHot && <HotBadge className={["flex"]} />}</div>
            {permission && !hasPermission(permission) && <PermissionBadge text={"Essential"} level={2} permission={permission} />}
          </div>
        </Text>
        {description && <p className="mt-1">
          <Text as="span" tone="subdued">{description}</Text>
        </p>}
      </div>
      {titleRight}
    </div>
    <div className={"mx-[-16px] mt-4 mb-1"}>
      <Divider />
    </div>
    {children}
  </Card>
}

export default ListCard
